import React, { useState, useEffect } from "react";
import { Globe } from "lucide-react";

import { companyInfo } from "../CompanyInfo/CompanyInfo";
import { Link, useLocation } from "react-router-dom";
import logo from "../pages/assets/eduit-logo.png";
import logo2 from "../pages/assets/Screenshot 2026-06-28 184333.png";

const PhoneIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.6 19.79 19.79 0 0 1 1.57 5.08 2 2 0 0 1 3.55 3h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.08a16 16 0 0 0 6.02 6.02l.65-.78a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const EmailIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const MapPinIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const ChevronDown = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const MenuIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const CloseIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const CodeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6" />
    <polyline points="8 6 2 12 8 18" />
  </svg>
);

const UsersIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const InfoIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

const navItems = [
  { label: "Home", path: "/" },
  {
    label: "About",
    id: "about-us",
    dropdown: [
      { label: "Our Story & Vision", path: "/about", desc: "Who we are and our values" },
      { label: "CEO Message", path: "/about/ceo-message", desc: "A direct message from our CEO" },
    ],
    icon: <InfoIcon />,
    color: "#10B981",
  },
  {
    label: "Recruitment",
    id: "recruitment-services",
    dropdown: [
      { label: "Executive Recruitment", path: "/services/recruitment-services", desc: "Top Management & Leadership" },
      { label: "Entry & Mid-Level Hiring", path: "/services/entry-middle-level-hiring", desc: "Talent for Every Level" },
      { label: "Third Party Payroll", path: "/services/payroll-services", desc: "Seamless Payroll Management" },
    ],
    icon: <UsersIcon />,
    color: "#7C3AED",
  },
  {
    label: "IT Services",
    id: "it-services",
    dropdown: [
      { label: "App Development", path: "/services/app-development", desc: "iOS, Android & Cross-Platform" },
      { label: "Web Development", path: "/services/web-development", desc: "Modern, Scalable Web Solutions" },
      { label: "Social Media Marketing", path: "/services/social-media-marketing", desc: "Grow Your Digital Presence" },
    ],
    icon: <CodeIcon />,
    color: "#2563EB",
  },
  { label: "Team", path: "/team" },
  { label: "Testimonials", path: "/testimonials" },
  { label: "Contact", path: "/contact" },
];

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setMobileExpanded(null);
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Top Contact Bar */}
      <div className="header-topbar">
        <div className="header-topbar-inner">
          <div className="topbar-contacts">
            <a href={`tel:${companyInfo.phone}`} className="topbar-contact-item">
              <PhoneIcon /> <span>{companyInfo.phone}</span>
            </a>
            <a href={`mailto:${companyInfo.email}`} className="topbar-contact-item">
              <EmailIcon /> <span>{companyInfo.email}</span>
            </a>
            <span className="topbar-contact-item topbar-address">
              <MapPinIcon /> <span>Noida, India &amp; Globe</span>
            </span>
          </div>
          <div className="topbar-right">
            <span className="topbar-tag" style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
              
              <Globe size={13} /> Serving Globally
            </span>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className={`header-main ${isScrolled ? "header-scrolled" : ""}`}>
        <div className="header-main-inner">
          {/* Logo */}
          <Link to="/" className="header-logo" onClick={() => { setIsMobileMenuOpen(false); window.scrollTo(0, 0); }} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <img src={logo} alt="EduITalent Logo" className="header-logo-img" />
          </Link>

          {/* Desktop Nav */}
          <nav className="header-nav-desktop">
            {navItems.map((item) =>
              item.dropdown ? (
                <div
                  key={item.id}
                  className={`nav-dropdown-wrapper ${activeDropdown === item.id ? "nav-dropdown-open" : ""}`}
                  onMouseEnter={() => setActiveDropdown(item.id)}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  <button className="nav-btn-dropdown">
                    <span className="nav-dropdown-icon">{item.icon}</span>
                    {item.label}
                    <span className={`nav-chevron ${activeDropdown === item.id ? "nav-chevron-open" : ""}`}>
                      <ChevronDown />
                    </span>
                  </button>
                  <div className="nav-dropdown-panel">
                    <div className="nav-dropdown-header">
                      <span className="nav-dropdown-label" style={{ color: item.color }}>{item.label}</span>
                    </div>
                    {item.dropdown.map((sub) => (
                      <Link
                        key={sub.path}
                        to={sub.path}
                        className="nav-dropdown-item"
                        onClick={() => { setActiveDropdown(null); window.scrollTo(0, 0); }}
                      >
                        <div className="nav-dropdown-item-dot" style={{ background: item.color }}></div>
                        <div>
                          <div className="nav-dropdown-item-label">{sub.label}</div>
                          <div className="nav-dropdown-item-desc">{sub.desc}</div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              ) : (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`nav-link-item ${isActive(item.path) ? "nav-link-active" : ""}`}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  {item.label}
                </Link>
              )
            )}
          </nav>

          {/* CTA */}
          <div className="header-cta-group">
            <Link to="/contact" className="header-cta-btn" onClick={() => window.scrollTo(0, 0)}>
              Free Consultation
            </Link>
            <img src={logo2} alt="Partner Logo" className="header-logo-img-partner" />
            <button
              className="header-mobile-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-nav-panel ${isMobileMenuOpen ? "mobile-nav-open" : ""}`}>
          <div className="mobile-nav-inner">
            {navItems.map((item) =>
              item.dropdown ? (
                <div key={item.id} className="mobile-nav-group">
                  <button
                    className="mobile-nav-group-btn"
                    onClick={() => setMobileExpanded(mobileExpanded === item.id ? null : item.id)}
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      {item.icon} {item.label}
                    </span>
                    <span className={`nav-chevron ${mobileExpanded === item.id ? "nav-chevron-open" : ""}`}>
                      <ChevronDown />
                    </span>
                  </button>
                  {mobileExpanded === item.id && (
                    <div className="mobile-nav-sub">
                      {item.dropdown.map((sub) => (
                        <Link
                          key={sub.path}
                          to={sub.path}
                          className="mobile-nav-sub-link"
                          onClick={() => { setIsMobileMenuOpen(false); window.scrollTo(0, 0); }}
                        >
                          <span className="mobile-sub-dot" style={{ background: item.color }}></span>
                          {sub.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`mobile-nav-link ${isActive(item.path) ? "mobile-nav-active" : ""}`}
                  onClick={() => { setIsMobileMenuOpen(false); window.scrollTo(0, 0); }}
                >
                  {item.label}
                </Link>
              )
            )}
            <Link
              to="/contact"
              className="mobile-nav-cta"
              onClick={() => { setIsMobileMenuOpen(false); window.scrollTo(0, 0); }}
            >
              Get Free Consultation
            </Link>
            
          </div>
        </div>
      </header>

      {/* Spacer to push content below fixed header */}
      <div className="header-spacer"></div>
    </>
  );
}
